<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Search Form
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">

                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                            label="Select Year"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="year.value.value"
                                            :items="yearsList"
                                            item-value="value"
                                            :error-messages="year.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            ></v-autocomplete>
                                        </v-col>

                                        <v-col md="2" cols="12">
                                            <v-btn
                                            class="bg-brand w-100"
                                            type="submit"
                                            ref="searchButton"
                                            >Search</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Leave Employee Wise Summary Report
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="px-2">
                                <v-row class="py-2 justify-items-between">

                                    <v-col cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                >CSV</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                >PDF</v-btn>

                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                </v-row>

                                <v-card class="my-2" elevation="0">
                                    <v-card-title class="bg-primary text-white text-center">
                                        <div class="w-100">
                                            <div class="text-h5 font-weight-bold">Leave Employee Wise Summary Report for {{ year.value.value? `${year.value.value}` : new Date().getFullYear() }} </div>
                                        </div>
                                    </v-card-title>
                                </v-card>

                                <v-data-table
                                :headers="headers"
                                :items="flattenedData"
                                :loading="loading"
                                v-model:items-per-page="itemsPerPage"
                                :search="search"
                                :hover="true"
                                density="compact"
                                class="custom-bordered-table"
                                >
                                    <template v-slot:item="{ item }">
                                        <tr>

                                            <td 
                                                v-if="item.isFirstRow" 
                                                :rowspan="item.employeeRowCount"
                                                class="text-center merged-cell"
                                                style="vertical-align: middle;"
                                            >
                                                {{ item.idx }}
                                            </td>
                                            
                                            <td 
                                                v-if="item.isFirstRow" 
                                                :rowspan="item.employeeRowCount"
                                                class="text-left merged-cell"
                                                style="vertical-align: middle;"
                                            >
                                                {{ item.employee_code }}
                                            </td>
                                            
                                            <td 
                                                v-if="item.isFirstRow" 
                                                :rowspan="item.employeeRowCount"
                                                class="text-left merged-cell"
                                                style="vertical-align: middle;"
                                            >
                                                {{ item.employee_name }}
                                            </td>
                                            
                                            <td class="text-left">{{ item.leave_name }}</td>
                                            <td class="text-right">{{ item.total }}</td>
                                            <td class="text-right">{{ item.used }}</td>
                                            <td class="text-right">{{ item.balance }}</td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed } from "vue";
import { toast } from "vue3-toastify";

export default {
    data: () => ({
        itemsPerPage: -1,
        panel: [0],
        panel2: [0],
        search: "",
        headers: [
            { title: "#SL", align: "center", key: "idx", width: "5%", sortable: false },
            { title: "Employee Code", key: "employee_code", align: "center", sortable: false, width: "150px" },
            { title: "Employee Name", key: "employee_name", align: "center", sortable: false, width: "200px" },
            { title: "Leave Type", key: "leave_name", align: "center", sortable: false, width: "180px" },
            { title: "Total", key: "total", align: "center", sortable: false, width: "100px" },
            { title: "Used", key: "used", align: "center", sortable: false, width: "100px" },
            { title: "Balance", key: "balance", align: "center", sortable: false, width: "100px" },
        ],
    }),
    computed: {
        getSchema() {
            return this.$store.getters.getLeaveEmployeeWiseSummaryReport;
        },
        flattenedData() {
            let sl = 0;
            const flattened = [];
            this.getSchema.forEach((employee) => {
                const employeeRowCount = employee.leave_summary.length;
                
                employee.leave_summary.forEach((leave, index) => {
                    flattened.push({
                        idx: index === 0 ? ++sl : "",
                        employee_code: index === 0 ? employee.employee_code : "",
                        employee_name: index === 0 ? employee.employee_name : "",
                        leave_name: leave.name,
                        total: leave.total,
                        used: leave.used,
                        balance: leave.balance, 
                        isFirstRow: index === 0,
                        rowIndex: index,
                        employeeRowCount: employeeRowCount,
                    });
                });
            });
            return flattened;
        },
        yearsList() {
            const startYear = 2025;
            const currentYear = new Date().getFullYear();
            const years = [];

            for (let y = startYear; y <= currentYear; y++) {
                years.push(y);
            }

            return years;
        }
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // Add your validation rules here
            }),
        });

        const year = useField("year");
        const loading = ref(false);
        const store = useStore();

        const submit = handleSubmit((values) => {
            loading.value = true;
            store
                .dispatch("getLeaveEmployeeWiseSummaryReport", values)
                .then((response) => {
                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error?.response?.data?.message || "An error occurred");
                });
        });

        return {
            year,
            submit,
            loading,
        };
    },
    methods: {
        exportToPDF() {
            const columns = [ "#SL", "Employee Code", "Employee Name", "Leave Type", "Total", "Used", "balance" ];

            const rows = this.flattenedData.map((item) =>
                [item.idx, item.employee_code, item.employee_name, item.leave_name, item.total, item.used, item.balance,]
            );

            this.$exportTableToPDF(
                columns,
                rows,
                "Leave Employee Wise Summary Report",
                "leave_employee_wise_summary_report_" + this.$fileDate()
            );
        },

        exportToExcel() {
            const data = [["#SL", "Employee Code", "Employee Name", "Leave Type", "Total", "Used", "balance"]];

            this.flattenedData.forEach(item => {
                data.push([ item.idx, item.employee_code, item.employee_name, item.leave_name, item.total, item.used, item.balance, ]);
            });

            this.$exportTableToExcel(data, "leave_employee_wise_summary_report_" + this.$fileDate());
        },

        exportToCSV() {
            const data = [["#SL", "Employee Code", "Employee Name", "Leave Type", "Total", "Used", "balance"]];

            this.flattenedData.forEach(item => {
                data.push([ item.idx, item.employee_code, item.employee_name, item.leave_name, item.total, item.used, item.balance, ]);
            });

            this.$exportTableToCSV(data, "leave_employee_wise_summary_report_" + this.$fileDate());
        },
    },

    mounted() {
        // this.$refs.searchButton.$el.click();
        this.year.value.value = new Date().getFullYear();
    },
};
</script>   

<style scoped>
.custom-bordered-table ::v-deep() table {
    border-collapse: collapse;
}

.custom-bordered-table ::v-deep() thead th,
.custom-bordered-table ::v-deep() tbody td {
    border: 1px solid #000000 !important;
    padding: 8px;
}

.custom-bordered-table {
    overflow-x: auto;
}

.custom-bordered-table ::v-deep() .merged-cell {
    font-weight: 500;
}
</style>